import { getConfig } from '@bmwe/data/shared';

import styles from './user.module.css';
import { UserRoleSimulator } from './UserRoleSimulator';

export interface UserProps {
  name?: string;
}

export function User({ name }: UserProps) {
  const showDevTools = import.meta.env.DEV || getConfig().DEV_TOOLS;

  return (
    <div className={styles['user-container']}>
      {name && <span className={styles['username']}>{name}</span>}
      {showDevTools && (
        <div className={styles['dev-tools']}>
          <UserRoleSimulator />
        </div>
      )}
    </div>
  );
}
